import { authorizedApi } from './index';

export const globetopperAuthorizedApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    initiatePurchase: builder.mutation({
      query: (purchaseData) => ({
        url: '/globetopper/initiate-purchase',
        method: 'POST',
        body: purchaseData,
      }),
    }),
    broadcastAndCreate: builder.mutation({
      query: (broadcastData) => ({
        url: '/globetopper/broadcast-and-create',
        method: 'POST',
        body: broadcastData,
      }),
      invalidatesTags: ['MyGiftCards'],
    }),
    getMyGiftCards: builder.query({
      query: () => ({
        url: '/globetopper/me',
        method: 'GET',
      }),
      providesTags: ['MyGiftCards'],
    }),
    estimatePayment: builder.query({
      query: ({ giftCardId, localAmount, paymentTokenMint, discountCode }) => ({
        url: '/globetopper/estimate-payment',
        method: 'GET',
        params: {
          giftCardId,
          localAmount,
          ...(paymentTokenMint ? { paymentTokenMint } : {}),
          ...(discountCode ? { discountCode } : {}),
        },
      }),
      // Completely disable RTK Query cache for this endpoint
      keepUnusedDataFor: 0,
      // Always refetch when arguments change
      refetchOnMountOrArgChange: true,
      // Don't provide tags to prevent any caching mechanism
      providesTags: [],
    }),
  }),
});

export const {
  useInitiatePurchaseMutation,
  useBroadcastAndCreateMutation,
  useGetMyGiftCardsQuery,
  useEstimatePaymentQuery,
} = globetopperAuthorizedApi;
